<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="100px" :model="form" disabled>
      <el-form-item label="UUID" style="margin-right:15px">
        <el-input v-model="form.code" />
      </el-form-item>
      <el-form-item label="关联code，分账表code" style="margin-right:15px">
        <el-input v-model="form.relatedCode" />
      </el-form-item>
      <el-form-item label="0分账" style="margin-right:15px">
        <el-input v-model="form.shareType" />
      </el-form-item>
      <el-form-item label="收款方商户号,原支付订单收款商户号" style="margin-right:15px">
        <el-input v-model="form.merchantId" />
      </el-form-item>
      <el-form-item label="关联网商订单号,原支付订单号" style="margin-right:15px">
        <el-input v-model="form.relateOrderNo" />
      </el-form-item>
      <el-form-item label="外部订单分账请求流水号，唯一标识一次分账请求" style="margin-right:15px">
        <el-input v-model="form.outTradeNo" />
      </el-form-item>
      <el-form-item label="网商分账退回订单号" style="margin-right:15px">
        <el-input v-model="form.shareRefundOrderNo" />
      </el-form-item>
      <el-form-item label="订单分账金额(金额为分)，此次订单分账总金额" style="margin-right:15px">
        <el-input v-model="form.totalAmount" />
      </el-form-item>
      <el-form-item label="状态，SUCCESS：成功,FAIL：失败,DEALING:处理中" style="margin-right:15px">
        <el-input v-model="form.status" />
      </el-form-item>
      <el-form-item label="分账退回时间（成功时出现）YYYYMMDDhhmmss" style="margin-right:15px">
        <el-input v-model="form.shareRefundDate" />
      </el-form-item>
      <el-form-item label="分账退回原因" style="margin-right:15px">
        <el-input v-model="form.reason" />
      </el-form-item>
      <el-form-item label="扩展信息,Map的json序列化后Base64" style="margin-right:15px">
        <el-input v-model="form.extInfo" />
      </el-form-item>
      <el-form-item label="备注" style="margin-right:15px">
        <el-input v-model="form.memo" />
      </el-form-item>
      <el-form-item label="错误码" style="margin-right:15px">
        <el-input v-model="form.errorCode" />
      </el-form-item>
      <el-form-item label="错误描述" style="margin-right:15px">
        <el-input v-model="form.errorDesc" />
      </el-form-item>
      <el-form-item label="退单表code" style="margin-right:15px">
        <el-input v-model="form.orderDetailRefundCode" />
      </el-form-item>
      <el-form-item label="运输单code" style="margin-right:15px">
        <el-input v-model="form.orderDetailCode" />
      </el-form-item>
      <el-form-item label="运输单号" style="margin-right:15px">
        <el-input v-model="form.orderDetailNumber" />
      </el-form-item>
      <el-form-item label="收款方code" style="margin-right:15px">
        <el-input v-model="form.partyCode" />
      </el-form-item>
      <el-form-item label="收款方姓名" style="margin-right:15px">
        <el-input v-model="form.partyName" />
      </el-form-item>
      <el-form-item label="收款方手机号" style="margin-right:15px">
        <el-input v-model="form.partyPhone" />
      </el-form-item>
      <el-form-item label="机构code" style="margin-right:15px">
        <el-input v-model="form.branchCode" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'MybankOrderShareRefundDetail',
  data() {
    return {
      emptyForm: {},
      form: {
        code: '',
        relatedCode: '',
        shareType: '',
        merchantId: '',
        relateOrderNo: '',
        outTradeNo: '',
        shareRefundOrderNo: '',
        totalAmount: '',
        status: '',
        shareRefundDate: '',
        reason: '',
        extInfo: '',
        memo: '',
        errorCode: '',
        errorDesc: '',
        orderDetailRefundCode: '',
        orderDetailCode: '',
        orderDetailNumber: '',
        partyCode: '',
        partyName: '',
        partyPhone: '',
        branchCode: ''
      }
    }
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({
        url: `/arpa-cloud-platform/mybankOrderShareRefund/${code}`,
        method: 'get'
      }).then((response) => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
